import axios from 'axios';
import { API_HOST } from '../consts';

const fetchGenderOptions = async (params) => {
  const res = await axios.get(`${API_HOST}/persons/gender`, { params });
  return res.data;
};

export default fetchGenderOptions;
